import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';

interface ClientConfig {
  onSuccess :(authCode :string) => void;
  onClose ?:() => void;
  onLoad ?:() => void;
  getLinkToken :() => Promise<string>;
  modalId ?:string;
}

declare global {
  interface Window {
    Trackstar :any;
    [key :string] :any;
  }
}

@Component({
  selector: 'lum-trackstar-connect-wms-button',
  templateUrl: './trackstar-connect-wms-button.component.html',
  styleUrls: ['./trackstar-connect-wms-button.component.scss'],
})
export class TrackstarConnectWmsButtonComponent implements OnInit, OnChanges {
  @Input()
  config :ClientConfig;

  @Input()
  disabled :boolean = false;

  @Input()
  scriptUrl :string;

  @Output()
  onClick = new EventEmitter<void>();

  error :any;
  loading :boolean = true;
  trackstarModalId :any;

  constructor() {}

  ngOnInit() :void {
    this.onLoadScript();
  }

  ngOnChanges({ config } :SimpleChanges) :void {
    if (config) {
      this.onLoadScript();
    }
  }

  private onLoadScript() :void {
    this.trackstarModalId = this.config.hasOwnProperty('modalId')
      ? 'Trackstar' + this.config.modalId
      : 'Trackstar';
    this.loadScript(this.scriptUrl)
      .then(() => {
        this.loading = false;

        if (window.Trackstar) {
          window.Trackstar.init({
            ...this.config,
            onLoad: () => {
              this.config.onLoad && this.config.onLoad();
            },
            onClose: () => this.config.onClose && this.config.onClose(),
            getLinkToken: () =>
              this.config.getLinkToken && this.config.getLinkToken(),
          });
        }
      })
      .catch((err) => {
        this.loading = false;
        this.error = err;
      });
  }

  private loadScript(src :string) :Promise<void> {
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.async = false;
      script.onload = () =>
        setTimeout(() => {
          resolve();
        });
      script.onerror = () => reject(`Error loading script: ${src}`);
      document.body.appendChild(script);
    });
  }

  open() :void {
    if (this.error) {
      throw new Error(`Error loading Trackstar script: ${this.error}`);
    }

    const modal = window[this.trackstarModalId];

    if (!modal) {
      console.error('Trackstar is not initialized');

      return;
    }

    if (!modal['state']?.isLoaded) {
      console.error(
        'Trackstar has not been loaded, did you call Trackstar.init()?',
      );

      return;
    }

    modal.open();
  }

  handleClick() :void {
    this.open();
  }
}
